import * as effects from 'redux-saga/effects'
import { State } from '.'

export enum ActionsNames {}

export type Actions = { type: 'NOOP' }

export function* saga() {
  yield effects.all([])
}

export const initialState: State = {}

export const reducer = (s = initialState, a: Actions): State => {
  switch (a.type) {
    default:
      return s
  }
}
